import { useState } from "react";
import Loading from "../../components/Loading";
import PrintDateModal from "./PrintDateModal";
import { useCustomerAttachmentPrint } from "../../utils/customerAttachment.utils";
import { printDate } from "../../utils/date.utils";
import CardTitle from "../../components/styled/CardTitle";
import Button from "../../ui/Button";
import { arrayMap } from "../../utils/array.utils";
import { PrintIcon } from "../../utils/icon.utils";

export default function MoneyReceiptOthersPrint({ data }) {
  const [printModal, setPrintModal] = useState(false);
  const [mrType, setMrType] = useState("");
  const [modalTitle, setModalTitle] = useState("");

  const printToggle = () => {
    setPrintModal((prev) => !prev);
  };

  // print money receipt
  const { printParams, setPrintParams, printCount, setPrintCount, printLoading } =
    useCustomerAttachmentPrint();

  const onPrint = (text) => {
    setMrType(text);
    printToggle();
  };

  const handlePrint = (submittedData) => {
    const { print_date, print_pad_type, bank_format } = submittedData;
    const id = data?.caid ? data.caid : "";
    setPrintParams({
      caid: id,
      time: printCount,
      printDate: print_date ? printDate(print_date) : null,
      mrType,
      print_pad_type,
      bank_format
    });
    setPrintCount((prev) => prev + 1);
  };

  // check money receipt is single or multiple
  const isMulti = data?.is_multi;
  const isMultiText = isMulti ? "multi" : "single";

  function handleMultiText(text) {
    return `${text}-${isMultiText}`;
  }

  // handle button click
  function handleButton(name, cb, mrType) {
    // set modal title
    setModalTitle(name);
    // call the button function
    cb(handleMultiText(mrType));
  }

  // print buttons
  const printButtons = [
    {
      name: "Pay Order",
      onClick: () => handleButton("Pay Order", onPrint, "pay-order"),
      color: "primary"
    },
    {
      name: "Delivery Challan",
      onClick: () =>
        handleButton("Customer Delivery Challan", onPrint, "delivery-challan-customer"),
      color: "success"
    },
    {
      name: "Delivery Challan (Bank)",
      onClick: () => handleButton("Bank Delivery Challan", onPrint, "delivery-challan-bank"),
      color: "info"
    },
    {
      name: "Delivery Acknowledgment (Customer)",
      onClick: () =>
        handleButton(
          "Customer Delivery Acknowledgment",
          onPrint,
          "delivery-acknowledgment-customer"
        ),
      color: "indigo"
    }
  ];

  return (
    <div className="card border-0">
      <div className="card-body">
        <CardTitle>Others Print</CardTitle>

        {/* print buttons */}
        <div className="d-flex flex-wrap gap-3 mt-3">
          {arrayMap(printButtons, (item, index) => (
            <Button
              icon={PrintIcon}
              key={index}
              color={item.color}
              name={item.name}
              onClick={item.onClick}
            />
          ))}
        </div>

        {printModal && (
          <PrintDateModal
            modal={printModal}
            toggle={printToggle}
            printDate={printParams.printDate}
            handlePrint={handlePrint}
            modalTitle={modalTitle}
          />
        )}

        <Loading loading={printLoading} />
      </div>
    </div>
  );
}
